import styled, {css} from 'styled-components';

import OldArrowDown from '~/assets/images/svgIconsAsText/basic-arrow-down.svg?react';
import ArrowDown from '~/assets/images/icons/chevron-right.svg?react';
import ArrowDownSmall from '~/assets/images/icons/chevron-right-small.svg?react';
import {rotateOnLTR} from '~/shared/theme/utils';

const arrowStyles = css`
  cursor: pointer;
  display: flex;
  transform: ${({theme}) => (theme.isLTR ? 'rotate3d(0, 0, 1, 90deg)' : 'rotate3d(0, 0, 1, -90deg)')};
`;

export const OldBackArrow = styled(OldArrowDown)`
  ${arrowStyles}
`;

const newArrowStyles = css`
  ${rotateOnLTR}
`;

export const BackArrowSmall = styled(ArrowDownSmall)`
  ${newArrowStyles}
  width: 14px;
  height: 14px;
`;

export const BackArrow = styled(ArrowDown)`
  ${newArrowStyles}
  width: 18px;
  height: 18px;
`;
